<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1"><a href="#/Text/4start#chap1">CHAPTER ONE</a></p>
<p class="toc1"><a href="#/Text/5chap2#chap2">CHAPTER TWO</a></p>
<p class="toc1"><a href="#/Text/6chap3#chap3">CHAPTER THREE</a></p>
<p class="toc1"><a href="#/Text/7chap4#chap4">CHAPTER FOUR</a></p>
<p class="toc1"><span href="#/Text/8chap5#chap5" title="Link target outside of Sample">CHAPTER FIVE</span></p>
<p class="toc1"><span href="#/Text/9chap6#chap6" title="Link target outside of Sample">CHAPTER SIX</span></p>
<p class="toc1"><span href="#/Text/10chap7#chap7" title="Link target outside of Sample">CHAPTER SEVEN</span></p>
<p class="toc1"><span href="#/Text/11chap8#chap8" title="Link target outside of Sample">CHAPTER EIGHT</span></p>
<p class="toc1"><span href="#/Text/12chap9#chap9" title="Link target outside of Sample">CHAPTER NINE</span></p>
<p class="toc1"><span href="#/Text/13chap10#chap10" title="Link target outside of Sample">CHAPTER TEN</span></p>
<p class="toc1"><span href="#/Text/14chap11#chap11" title="Link target outside of Sample">CHAPTER ELEVEN</span></p>
<p class="toc1"><span href="#/Text/15chap12#chap12" title="Link target outside of Sample">CHAPTER TWELVE</span></p>
<p class="toc1"><span href="#/Text/16chap13#chap13" title="Link target outside of Sample">CHAPTER THIRTEEN</span></p>
<p class="toc1"><span href="#/Text/17chap14#chap14" title="Link target outside of Sample">CHAPTER FOURTEEN</span></p>
<p class="toc1"><span href="#/Text/18chap15#chap15" title="Link target outside of Sample">CHAPTER FIFTEEN</span></p>
<p class="toc1"><span href="#/Text/19chap16#chap16" title="Link target outside of Sample">CHAPTER SIXTEEN</span></p>
<p class="toc1"><span href="#/Text/20chap17#chap17" title="Link target outside of Sample">CHAPTER SEVENTEEN</span></p>
<p class="toc1"><span href="#/Text/21chap18#chap18" title="Link target outside of Sample">CHAPTER EIGHTEEN</span></p>
<p class="toc1"><span href="#/Text/22chap19#chap19" title="Link target outside of Sample">CHAPTER NINETEEN</span></p>
<p class="toc1"><span href="#/Text/23chap20#chap20" title="Link target outside of Sample">CHAPTER TWENTY</span></p>
<p class="toc1"><span href="#/Text/24chap21#chap21" title="Link target outside of Sample">CHAPTER TWENTY-ONE</span></p>
<p class="toc1"><span href="#/Text/25chap22#chap22" title="Link target outside of Sample">CHAPTER TWENTY-TWO</span></p>
<p class="toc1"><span href="#/Text/26chap23#chap23" title="Link target outside of Sample">CHAPTER TWENTY-THREE</span></p>
<p class="toc1"><span href="#/Text/27chap24#chap24" title="Link target outside of Sample">CHAPTER TWENTY-FOUR</span></p>
<p class="toc1"><span href="#/Text/28chap25#chap25" title="Link target outside of Sample">CHAPTER TWENTY-FIVE</span></p>
<p class="toc1"><span href="#/Text/29chap26#chap26" title="Link target outside of Sample">CHAPTER TWENTY-SIX</span></p>
<p class="toc1"><span href="#/Text/30chap27#chap27" title="Link target outside of Sample">CHAPTER TWENTY-SEVEN</span></p>
<p class="toc1"><span href="#/Text/31chap28#chap28" title="Link target outside of Sample">CHAPTER TWENTY-EIGHT</span></p>
<p class="toc1"><span href="#/Text/32chap29#chap29" title="Link target outside of Sample">CHAPTER TWENTY-NINE</span></p>
<p class="toc1"><span href="#/Text/33chap30#chap30" title="Link target outside of Sample">CHAPTER THIRTY</span></p>
<p class="toc1"><span href="#/Text/34chap31#chap31" title="Link target outside of Sample">CHAPTER THIRTY-ONE</span></p>
<p class="toc1" style="margin-top:20px;"><span href="#/Text/teaser00" title="Link target outside of Sample">Preview: <i>Roux the Day</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3TOC.vue?375f509e